  <div class="load_center" *ngIf="!hasInitialized; else afterInit">
    <img alt="loading" class="heartbeat" [src]="heartbeatLogoUrl" />
  </div>

  <ng-template #afterInit>
    <!-- The shell owns the viewport height and hands what the title bar leaves to the body, so a
         shorter title bar grows the content area instead of shifting it. -->
    <div class="app-component mat-typography flex h-screen flex-col overflow-y-clip">
      <!-- Sizes to its content: pages that hide the quick filters get no empty band. Nothing is
           positioned from its height; the side-menu toggle lives inside the body row below. -->
      <div class="flex min-h-12 flex-none flex-row">
        <!-- The logo is absolutely positioned inside this slot, so it fills the bar rather than
             setting its height. -->
        <div class="relative w-nav flex-none">
          <ng-container *ngIf="!logoHyperlink; else LinkedLogo">
            <a
            class="tap-home-item"
            id="tap-home-item"
            [routerLink]="['dashboard']"
            routerLinkActive="active"
            fxLayoutAlign="center center"
            [style.backgroundColor]="logoBackgroundColor"
          >
            <img alt="logo" [src]="logoSource" class="h-full w-full object-contain" />
          </a>
          </ng-container>
        </div>
        <div class="flex w-full flex-col bg-surface">
          <div
            *ngIf="isImpersonating"
            class="impersonation-overlay"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            <span>{{ 'Impersonation.Banner' | translate }} {{ (currentUser$ | async)?.userName }}</span>
            <button mat-button color="warn" (click)="stopImpersonation()">{{ 'User.Header.StopImpersonating' | translate }}</button>
          </div>
          <!-- The server only sends passwordExpiresOn inside the warning window. -->
          <ng-container *ngIf="(currentUser$ | async)?.passwordExpiresOn as passwordExpiresOn">
            <app-tap-alert
              *ngIf="!passwordBannerDismissed"
              type="warning"
              message="PasswordExpiry.Banner"
              [messageParams]="{ date: passwordExpiresOn | date: 'mediumDate' }"
              [dismissible]="true"
              (dismissed)="passwordBannerDismissed = true"
            >
              <a [routerLink]="['my-account']">{{ 'PasswordExpiry.ChangeNow' | translate }}</a>
            </app-tap-alert>
          </ng-container>
          <app-header [logoHyperlink]="logoHyperlink" [logoSource]="logoSource">
          </app-header>
          <mat-card-header
            [hidden]="hideTitleBarFilters$ | async"
            class="section-panel-header"
          >
            <h3 class="section-panel-header-text">
              {{ pageTitleBarResourceKey | translate }}
            </h3>
            <router-outlet name="pageToolbar"></router-outlet>

          </mat-card-header>
          <app-tank-quick-filters
            [hidden]="(hideTankFilters$ | async) === true"
          ></app-tank-quick-filters>
        </div>
      </div>

      <!-- relative: the side-menu toggle is positioned from the top of this row, not the page, so
           it follows the title bar whatever height that bar ends up. -->
      <div class="relative min-h-0 flex-1">
        <mat-sidenav-container>
          <!----------  Main Menu  ---------->
          <mat-sidenav
            #sidenav
            id="leftSideNav"
            fxLayout="column"
            opened="true"
            mode="side"
            disableClose="true"
          >
            <div
              #sideNavMenuElement
              fxLayout="column"
              center
              [ngClass]="{
                sideMenuButtonContainer: true,
                sideMenuButtonContainerWidth: menuPanelIsClosed === false,
                sideMenuButtonContainerWidthNarrow: menuPanelIsClosed === true
              }"
            >
              <mat-nav-list style="padding-top: unset; border: solid 2px rgb(60, 62, 60)">
                <!--Dashboard-->
                <a
                  mat-list-item
                  [routerLink]="['dashboard']"
                  routerLinkActive="active"
                >
                  <svg-icon
                    class="side-nav-icon"
                    src="assets/svg/analytics.svg"
                    fill=""
                  ></svg-icon>
                  <svg-icon
                    class="side-nav-icon-active"
                    src="assets/svg/analytics-active.svg"
                  ></svg-icon>
                  <span [hidden]="menuPanelIsClosed" class="menu_label">
                    {{ 'PageMenu.Dashboard' | translate }}
                  </span>
                </a>

                <!--Tanks-->
                <a
                  mat-list-item
                  [routerLink]="['tank']"
                  routerLinkActive="active"
                >
                  <svg-icon
                    class="side-nav-icon"
                    src="assets/svg/tanks.svg"
                    fill=""
                  ></svg-icon>
                  <svg-icon
                    class="side-nav-icon-active"
                    src="assets/svg/tanks-active.svg"
                  ></svg-icon>
                  <span [hidden]="menuPanelIsClosed" class="menu_label">
                    {{ 'PageMenu.Tanks' | translate }}
                  </span>
                </a>

                <a
                mat-list-item
                [routerLink]="['location']"
                routerLinkActive="active"
                appAuthorization
                [policy]="policies.RequiresManageLocations"

              >
                <svg-icon
                  class="side-nav-icon"
                  src="assets/svg/loc.svg"
                ></svg-icon>
                <svg-icon
                  class="side-nav-icon-active"
                  src="assets/svg/loc.svg"
                ></svg-icon>
                <span [hidden]="menuPanelIsClosed" class="menu_label">{{
                  'PageMenu.Locations' | translate
                }}</span>
              </a>

                <a
                  *ngIf="Features.reporting === true"
                  mat-list-item
                  [routerLink]="['report']"
                  routerLinkActive="active"
                >
                  <svg-icon
                    class="side-nav-icon"
                    src="assets/svg/report-nav.svg"
                    fill=""
                  ></svg-icon>
                  <svg-icon
                    class="side-nav-icon-active"
                    src="assets/svg/report-nav-active.svg"
                  ></svg-icon>
                  <span [hidden]="menuPanelIsClosed" class="menu_label">
                    {{ 'PageMenu.Reports' | translate }}
                  </span>
                </a>
                <mat-divider [hidden]="menuPanelIsClosed"></mat-divider>

                <!--Organizations-->
                <a
                  mat-list-item
                  siteUsageTracker
                  [logCategory]="'sideNav'"
                  [logName]="'NavigateToOrganizations'"
                  [routerLink]="['organization']"
                  routerLinkActive="active"
                  appAuthorization
                  [policy]="policies.RequiresManageOrganizationsOrPremiumServices"
                >
                  <svg-icon
                    class="side-nav-icon"
                    src="assets/svg/org.svg"
                  ></svg-icon>
                  <svg-icon
                    class="side-nav-icon-active"
                    src="assets/svg/org-circle.svg"
                  ></svg-icon>
                  <span [hidden]="menuPanelIsClosed" class="menu_label">
                    {{ 'PageMenu.Orgs' | translate }}
                  </span>
                </a>

                <!--Users-->
                <a
                  mat-list-item
                  [routerLink]="['user']"
                  routerLinkActive="active"
                  appAuthorization
                  [policy]="policies.RequiresManageUsers"

                >
                  <svg-icon
                    class="side-nav-icon"
                    src="assets/svg/user.svg"
                  ></svg-icon>
                  <svg-icon
                    class="side-nav-icon-active"
                    src="assets/svg/user.svg"
                  ></svg-icon>
                  <span [hidden]="menuPanelIsClosed" class="menu_label">{{
                    'PageMenu.Users' | translate
                  }}</span>
                </a>
                <!--Tank Notifications-->
                <!-- <a
                  mat-list-item
                  siteUsageTracker
                  [logCategory]="'sideNav'"
                  [logName]="'NavigateToTankNotifications'"
                  [routerLink]="['notifications', '0']"
                  routerLinkActive="active"
                >
                  <svg-icon
                    class="side-nav-icon white-svg"
                    src="assets/svg/notify.svg"
                  ></svg-icon>
                  <svg-icon
                    class="side-nav-icon-active"
                    src="assets/svg/notify.svg"
                  ></svg-icon>
                  <span [hidden]="menuPanelIsClosed" class="menu_label">
                    {{ 'PageMenu.TankNotifications' | translate }}
                  </span>
                </a> -->
                <!--Settings-->
                <a
                  mat-list-item
                  (click)=" showSettingsSidebar()"
                >
                  <svg-icon
                    class="side-nav-icon"
                    src="assets/svg/settings.svg"
                  ></svg-icon>
                  <span [hidden]="menuPanelIsClosed" class="menu_label">
                    {{ 'PageMenu.Settings' | translate }}
                  </span>
                </a>
                <mat-divider [hidden]="menuPanelIsClosed"></mat-divider>
                <!--Switch to legacy view-->
                <left-nav-secondary-links
                  [hidden]="menuPanelIsClosed || themeEnabled"
                ></left-nav-secondary-links>
                <div class="buildInfoCard" [hidden]="!(showBuildInfo$ | async)">
                  <div class="mat-card">
                    {{ buildInfo }}
                  </div>
                </div>
              </mat-nav-list>
            </div>
          </mat-sidenav>

          <div style="height: 2px;">
            <span [hidden]="!(loading$ | async)">
              <mat-progress-bar
                color="accent"
                mode="indeterminate"
              ></mat-progress-bar>
            </span>
          </div>
          <router-outlet></router-outlet>
        </mat-sidenav-container>

        <div
          class="menuSideNavOpenClose"
          [ngStyle]="{ left: getMenuClosePosition() }"
        >
          <svg-icon
            [hidden]="menuPanelIsClosed"
            src="{{ expandIcon }}"
            (click)="showLeftSideNavNarrow()"
            [ngClass]="this.isDashboard === true ? 'tap-themeable' : ''"
          ></svg-icon>
          <svg-icon
            [hidden]="!menuPanelIsClosed"
            src="{{ collapseIcon }}"
            (click)="showLeftSideNav()"
            [ngClass]="this.isDashboard === true ? 'tap-themeable' : ''"
          ></svg-icon>
        </div>
      </div>

      <!-- <app-footer></app-footer> -->
    </div>
  </ng-template>


  <ng-template #LinkedLogo>
      <a
      class="tap-home-item"
      [style.backgroundColor]="logoBackgroundColor"
      fxLayoutAlign="center center"
      style="width: 100%; height: 100%;background-image: url('{{ logoSource }}');background-size: contain;background-repeat: no-repeat; background-position: center;"
      target="_blank"
      [href]="logoHyperlink"
      >
    </a>
  </ng-template>
